<template>
    <div class="product-slider" v-if="images.length > 0">
        <slick :slickOptions="slickOptions" tag="div">
            <div
                class="slider-item"
                v-for="(image, index) in images"
                :key="index"
            >
                <div class="image-fit">
                    <img :src="image" alt />
                </div>
            </div>
        </slick>
    </div>
</template>
<script>
import Slick from "vue-slick";
import { get } from "lodash";
export default {
    name: "RoomImagesSlide",
    components: { Slick },
    props: ["room"],
    data() {
        return {
            images: [],
            slickOptions: {
                infinite: true,
                autoplay: true
            }
        };
    },
    mounted() {
        this.images = get(this, "room.info.situations", []);
    },
    watch: {
      room: function(room) {
        this.images = get(room, "info.situations", []);
      }
    }
};
</script>
